const API_BASE_URL = process.env.BASE_URL

export const NOTIFICATION_ENDPOINTS = {
    RETRIEVE_NOTIFICATION_PREFERENCES: API_BASE_URL + "/user/me/notification-preferences/",
    RETRIEVE_NOTIFICATION_METHODS: API_BASE_URL + "/user/me/notification-methods/",
    UPDATE_NOTIFICATION_PREFERENCES: API_BASE_URL + "/user/me/notification-preferences/",
    UPDATE_NOTIFICATION_METHODS: API_BASE_URL + "/user/me/notification-methods/",
}
